import { Modal } from "@xola/ui-kit";
import { Loader } from "common";
import React from "react";
import { ApiKeyUser } from "types";
import { CopyableField } from "@/components/Common/CopyableField";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { useResource } from "@/hooks/useResource";
import { getSeller } from "@/utils/getSeller";

interface CreatedApiKeyModalProps {
    apiKeyId: string;
    isOpen: boolean;
    onClose: () => void;
}

export const CreatedApiKeyModal = ({ apiKeyId, isOpen, onClose }: CreatedApiKeyModalProps) => {
    const seller = getSeller();
    const { data, isLoading } = useResource<ApiKeyUser>(["sellers", seller.id, "apiKeys", apiKeyId]);
    const apiKey = data?.apiKey;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Header>API Key Created</Modal.Header>
            <Modal.Body>
                <div className="space-y-4">
                    <p className="text-gray-darker">Your API key has been created successfully.</p>
                    <div className="rounded bg-gray-light p-4">
                        {isLoading || !apiKey ? (
                            <Loader />
                        ) : (
                            apiKey && (
                                <CopyableField data={apiKey} dataTestId="created-api-key">
                                    <span className="font-mono text-sm">{apiKey}</span>
                                </CopyableField>
                            )
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <SecondaryButton onClick={onClose}>Close</SecondaryButton>
            </Modal.Footer>
        </Modal>
    );
};
